<div class="page-content">
  <div class="title-box">
    <!-- <span class="title">{{ "NO_AUTH" | translate }}</span> -->
  </div>

  <div class="container">
    {{ "NO_PERMISSION" | translate }}
  </div>
</div>
